<form [formGroup]="loginForm" (ngSubmit)="checkForm() && !loading && sendLogin()">
  <div class="flex flex-col gap-2">
    <mat-form-field class="input-tg w-full" appearance="outline" hideRequiredMarker="true">
      <mat-label>Nova senha</mat-label>
      <mat-icon matPrefix class="icone-campo" fontIcon="lock_outline"></mat-icon>
      <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="new-password" />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hidePassword = !hidePassword"
        [attr.aria-label]="hidePassword ? 'Mostrar senha' : 'Ocultar senha'"
        [attr.aria-pressed]="!hidePassword"
      >
        <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field class="input-tg w-full" appearance="outline" hideRequiredMarker="true">
      <mat-label>Confirme a nova senha</mat-label>
      <mat-icon matPrefix class="icone-campo" fontIcon="lock_outline"></mat-icon>
      <input matInput [type]="hidePassword2 ? 'password' : 'text'" formControlName="new_password" autocomplete="new-password" />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hidePassword2 = !hidePassword2"
        [attr.aria-label]="hidePassword2 ? 'Mostrar senha' : 'Ocultar senha'"
        [attr.aria-pressed]="!hidePassword2"
      >
        <mat-icon>{{ hidePassword2 ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <button
    mat-flat-button
    type="submit"
    class="btn-tg w-full mt-4 h-12"
    [disabled]="!checkForm() || loading"
  >
    @if (loading) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
    } @else {
      Confirmar alteração
    }
  </button>
</form>
